import type { SelectableLanguageCode } from "./i18n"

const currencyCodes = [
  "CAD", // Canadian Dollar
  "CHF", // Swiss Franc
  "DKK", // Danish Krone
  "EUR", // Euro
  "GBP", // Pound Sterling
  "JPY", // Japanese Yen
  "NOK", // Norwegian Krone
  "SEK", // Swedish Krona
  "SGD", // Singapore Dollar
  "THB", // Thai Baht
  "USD", // US Dollar
] as const

export type CurrencyCode = (typeof currencyCodes)[number]

export const supportedCurrencyCodes: CurrencyCode[] = currencyCodes.filter(
  (currencyCode) =>
    currencyCode === "JPY" || currencyCode === "THB" || currencyCode === "USD"
)

// Orgs do not yet have a default currency (e.g. organization.currency)
// This maps a locale (e.g. organization.locale) to a currency
// so we can get an org's default currency
export const LocaleCodeToCurrencyCodeMap = new Map<
  SelectableLanguageCode,
  CurrencyCode
>([
  // ["da-DK", "DKK"], // Danish Denmark
  // ["nl-NL", "EUR"], // Dutch Netherlands
  // ["en-CA", "CAD"], // English Canada
  // ["en-GB", "GBP"], // English Great Britain
  // ["en-IE", "EUR"], // English Ireland
  // ["en-SG", "SGD"], // English Singapore
  ["en-US", "USD"], // English United States
  // ["fr-BE", "EUR"], // French Belgium
  // ["fr-FR", "EUR"], // French France
  // ["fr-LU", "EUR"], // French Luxembourg
  // ["fr-CH", "CHF"], // French Switzerland
  // ["de-DE", "EUR"], // German Germany
  // ["de-LU", "EUR"], // German Luxembourg
  // ["de-CH", "CHF"], // German Switzerland
  // ["it-IT", "EUR"], // Italian Italy
  // ["it-CH", "CHF"], // Italian Switzerland
  ["ja", "JPY"], // Japanese Japan
  ["ja-JP", "JPY"], // Japanese Japan
  // ["no-NO", "NOK"], // Norwegian Norway
  // ["es-ES", "EUR"], // Spanish Spain
  // ["sv-SE", "SEK"], // Swedish Sweden
  ["th", "THB"], // Thai Thailand
  ["th-TH", "THB"], // Thai Thailand
])
